<div
  style="
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 99vw;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: nowrap;
  "
>
  <app-spinner-full-page></app-spinner-full-page>
  <p-toast position="top-right" />

  <div style="order: 1; flex: 0 0 auto">
    <app-header></app-header>
  </div>
  <div style="order: 2; flex: 1 1 auto; min-width: 0; overflow: auto">
    <router-outlet></router-outlet>
  </div>
  <div style="order: 3; flex: 0">
    <app-footer> </app-footer>
  </div>
</div>
